export const getCSV = (header, elements) => {
  let csv = '';
  csv += header.map(a => `"${a}"`).join(',') + '\n';
  elements.forEach(element => {
    const row = header.map(h => element[h]);
    csv += row.map(a => a && a !== '' ? `"${a}"` : '').join(',') + '\n';
  });
  return csv;
}